var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { defaultIconProps } from '../icon';
export var IconWarning = function (props) { return (_jsx("span", __assign({ className: "icon icon__tick" }, { children: _jsx("svg", __assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.60752 5.1015L8.15202 10.4794C8.10981 10.6354 7.88853 10.6354 7.84632 10.4794L6.39083 5.1015C6.10416 4.04229 6.90186 3 7.99917 3C9.09648 3 9.89418 4.04229 9.60752 5.1015ZM8.99963 12C8.99963 12.5523 8.55191 13 7.99963 13C7.44734 13 6.99963 12.5523 6.99963 12C6.99963 11.4477 7.44734 11 7.99963 11C8.55191 11 8.99963 11.4477 8.99963 12Z", fill: props.fill || defaultIconProps.fill }) })) }))); };
